// @flow
import React, { useContext } from 'react';
import { useFormikContext } from 'formik';

import {
  AWS,
  AZURE,
  GCP,
  NATIVE_INFERENCE_POOL_PROVIDER_BACKEND_NAME,
  NATIVE_INFERENCE_POOL_REGION_BACKEND_NAME,
} from '../../../constants';
import { getDropdownOptions } from '../../stream-governance/utils';
import { SelectField } from '../../../formik-utils/FormFields';
import { NATIVE_INFERENCE_POOL_DETAILS_CONFIG_MAP } from '../../../configuration/native-inference-pool-details';
import { NativeInferencePoolContext } from '../../../contexts/NativeInferencePoolContext';

export const NativeInferencePoolProviderContainer = ({ disabled }) => {
  const { values, setFieldValue, setFieldTouched } = useFormikContext();
  const nativeInferencePoolProviderConfig = NATIVE_INFERENCE_POOL_DETAILS_CONFIG_MAP.get(
    NATIVE_INFERENCE_POOL_PROVIDER_BACKEND_NAME
  );

  const nativeInferencePool = useContext(NativeInferencePoolContext);
  const dataUniverse = nativeInferencePool?.native_inference_configs?.provider_details ?? [];

  const nativeInferencePoolProviderOptions = getDropdownOptions(
    dataUniverse,
    values,
    nativeInferencePoolProviderConfig,
    false,
    true,
    false,
    false,
    [AWS, AZURE, GCP]
  );

  return (
    <SelectField
      disabled={disabled}
      fieldDisplayName={nativeInferencePoolProviderConfig.displayName}
      fieldName={nativeInferencePoolProviderConfig.backendFieldName}
      onChange={() => {
        setFieldTouched(NATIVE_INFERENCE_POOL_REGION_BACKEND_NAME, true);
        setFieldValue(NATIVE_INFERENCE_POOL_REGION_BACKEND_NAME, null);
      }}
      options={nativeInferencePoolProviderOptions}
      placeholder={null}
    />
  );
};
